import React from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Avatar,
  Rating,
  Grid,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import { tokens } from "../theme/tokens";

const UserReviews = () => {
  const reviews = [
    {
      id: 1,
      name: "Manish Gautam",
      role: "Business Traveler",
      rating: 5,
      review:
        "Amazing experience! Found the perfect hotel for our family vacation. The booking process was seamless and the customer service exceeded our expectations.",
      avatar: "MG",
    },
    {
      id: 2,
      name: "Sager Chauhan",
      role: "Business Traveler",
      rating: 5,
      review:
        "Incredible service! Booked a last-minute business trip and everything was perfect. The hotel recommendations were spot-on and the prices were unbeatable.",
      avatar: "SC",
    },
    {
      id: 3,
      name: "Sumit Gupta",
      role: "Business Traveler",
      rating: 5,
      review:
        "Absolutely love this platform! Found a beautiful boutique hotel that wasn't available anywhere else. The hotel was exactly as described.",
      avatar: "SG",
    },
  ];

  return (
    <Box
      sx={{
        py: { xs: 8, md: 10 },
        bgcolor: tokens.paper,
        borderTop: `1px solid ${tokens.border}`,
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: { xs: 5, md: 7 }, maxWidth: 640, mx: "auto" }}>
          <Typography
            variant="overline"
            sx={{
              color: tokens.accent,
              fontWeight: 700,
              letterSpacing: "0.14em",
              display: "block",
              mb: 1,
            }}
          >
            Social proof
          </Typography>
          <Typography
            variant="h4"
            component="h2"
            sx={{
              mb: 2,
              fontWeight: 700,
              color: tokens.text,
              fontFamily: tokens.fontDisplay,
              letterSpacing: "-0.02em",
              fontSize: { xs: "1.5rem", md: "2rem" },
            }}
          >
            Trusted by travel buyers
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: tokens.textMuted,
              fontSize: { xs: "0.95rem", md: "1.05rem" },
              lineHeight: 1.7,
            }}
          >
            Each journey with us is more than just a trip—it is a polished experience from search to
            confirmation.
          </Typography>
        </Box>

        <Grid container spacing={{ xs: 3, md: 4 }}>
          {reviews.map((review) => (
            <Grid item xs={12} sm={6} md={4} key={review.id}>
              <Card
                elevation={0}
                sx={{
                  height: "100%",
                  borderRadius: `${tokens.radiusLg}px`,
                  border: `1px solid ${tokens.border}`,
                  boxShadow: tokens.shadowSm,
                  display: "flex",
                  flexDirection: "column",
                  transition: "box-shadow 0.25s ease, transform 0.25s ease",
                  "&:hover": {
                    boxShadow: tokens.shadowMd,
                    transform: "translateY(-4px)",
                  },
                }}
              >
                <CardContent sx={{ p: 3, flex: 1, display: "flex", flexDirection: "column" }}>
                  <FormatQuoteIcon
                    sx={{
                      fontSize: 36,
                      color: tokens.highlight,
                      opacity: 0.9,
                      mb: 2,
                    }}
                  />
                  <Typography
                    variant="body1"
                    sx={{
                      color: tokens.text,
                      lineHeight: 1.75,
                      mb: 3,
                      fontSize: "0.95rem",
                      flex: 1,
                    }}
                  >
                    “{review.review}”
                  </Typography>
                  <Rating
                    value={review.rating}
                    readOnly
                    size="small"
                    icon={<StarIcon sx={{ color: tokens.highlight, fontSize: 22 }} />}
                    emptyIcon={<StarIcon sx={{ color: tokens.border, fontSize: 22 }} />}
                  />
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 3 }}>
                    <Avatar
                      sx={{
                        width: 48,
                        height: 48,
                        bgcolor: tokens.brand,
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "1rem",
                      }}
                    >
                      {review.avatar}
                    </Avatar>
                    <Box>
                      <Typography variant="subtitle1" sx={{ fontWeight: 700, color: tokens.text }}>
                        {review.name}
                      </Typography>
                      <Typography variant="body2" sx={{ color: tokens.textMuted, fontWeight: 500 }}>
                        {review.role}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Box
          sx={{
            textAlign: "center",
            mt: { xs: 6, md: 8 },
            p: { xs: 3, md: 4 },
            borderRadius: `${tokens.radiusLg}px`,
            background: `linear-gradient(135deg, ${tokens.accentSoft} 0%, ${tokens.highlightSoft} 100%)`,
            border: `1px solid ${tokens.border}`,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: tokens.brand,
              fontWeight: 700,
              mb: 1,
              fontFamily: tokens.fontDisplay,
            }}
          >
            Ready to streamline your next program?
          </Typography>
          <Typography variant="body2" sx={{ color: tokens.textMuted, maxWidth: 480, mx: "auto" }}>
            Use the search above to explore live rates—or open your account menu for bookings and
            history.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default UserReviews;
